//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';
import TradersCurrencies from '~/views/TradersCurrenciesAndPaymentMethods/TradersCurrencies/Table.vue';
import TradersPaymentMethods from '~/views/TradersCurrenciesAndPaymentMethods/TradersPaymentMethods/Table.vue';
import TradersTransactionMethods from '~/views/TradersCurrenciesAndPaymentMethods/TradersTransactionMethods/Table.vue';

export default {
  components: {
    TradersCurrencies,
    TradersPaymentMethods,
    TradersTransactionMethods,
  },

  async mounted() {
    this.setGeneralLoader(true);
    await Promise.allSettled([
      this.loadCurrencies(),
      this.loadPaymentMethods(),
      this.loadTransactionMethods(),
    ]);
    this.setGeneralLoader(false);
  },

  methods: {
    ...mapActions('common', ['setGeneralLoader']),
    ...mapActions('tradersCurrencies', {
      loadCurrencies: 'loadData',
    }),
    ...mapActions('tradersPaymentMethods', {
      loadPaymentMethods: 'loadData',
    }),
    ...mapActions('tradersTransactionMethods', {
      loadTransactionMethods: 'loadData',
    }),
  },
};
